import React from 'react';

import { HOC } from 'formsy-react';
import FormInput from './FormInput';

import { DropdownOptions } from '../../constants/DropdownOptions';

export class Dropdown extends FormInput {
    onChange(event) {
        if (this.props.handleChange) {
            this.props.handleChange(event);
        }

        super.onChange(event);
    }

    renderLabel() {
        if (!this.props.label) {
            return '';
        }

        if (this.props.labelMobileOnly) {
            return (
                <div className="app__dropdown__label--mobile">
                    { this.props.label }
                </div>
            );
        }

        return <div className="app__dropdown__label">
            { this.props.label }
        </div>;
    }

    renderOptions() {
        const optionsElements = [];
        let listOfOptions = this.props.options;

        if (!listOfOptions && !this.props.optionsType) {
            listOfOptions = DropdownOptions.get(this.props.name);
        } else if (this.props.optionsType) {
            listOfOptions = DropdownOptions.get(this.props.optionsType);
        }

        if (!listOfOptions || !listOfOptions.length) {
            return '';
        }

        if (this.props.blankOption) {
            const defaultBlankOptionLabel = this.props.label ? this.props.label.toLowerCase() : 'an option';
            const blankOptionLabel = this.props.blankOptionLabel ? this.props.blankOptionLabel :
                defaultBlankOptionLabel;

            optionsElements.push(
                <option value="">
                    -- select { blankOptionLabel } --
                </option>
            );
        }

        for (let i = 0; i < listOfOptions.length; i++) {
            const option = listOfOptions[i];
            optionsElements.push(<option value={ option.value }>{ option.text }</option>);
        }
        return optionsElements;
    }

    render() {
        const widthProportion = this.props.widthProportion ? this.props.widthProportion : 'full';
        const requiredClass = this.showRequired() ? 'app__dropdown__dropdown--required' : '';

        let style = {};
        if (this.props.fixedWidth) {
            style = {
                width: this.props.fixedWidth,
            };
        }

        return <div className="app__dropdown">
            { this.renderLabel() }
            <select className={ `app__dropdown__dropdown ${widthProportion} ${requiredClass}` }
                    onChange={ this.onChange.bind(this) }
                    onBlur={ this.onBlur.bind(this) }
                    name={ this.props.name }
                    value={ this.props.value }
                    defaultValue=""
                    style={ style }>
                { this.renderOptions() }
            </select>
        </div>;
    }
}

Dropdown.propTypes = {
    label: React.PropTypes.string,
    labelMobileOnly: React.PropTypes.bool,
    value: React.PropTypes.node,

    options: React.PropTypes.array,
    optionsType: React.PropTypes.string,

    name: React.PropTypes.string,
    handleChange: React.PropTypes.func,
    widthProportion: React.PropTypes.string,
    fixedWidth: React.PropTypes.string,

    blankOption: React.PropTypes.bool,
    blankOptionLabel: React.PropTypes.string,

    invalidSubmit: React.PropTypes.bool,
};

export default HOC(Dropdown);



// WEBPACK FOOTER //
// ./src/components/elements/Dropdown.jsx